export const stripNonAlphanumeric = (value: string) => {
    value.replace(/[^a-zA-Z0-9]/g, "");
    return value;
};
